// ListaAulas.js - CORRIGIDA
import { Button, Typography, Box } from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import LinearProgress from "@mui/material/LinearProgress";
import { useTheme, useMediaQuery } from "@mui/material";

export function ListaAulas({ aulas, videoSelecionado }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        height: isMobile ? "95%" : "80%",
        overflowY: "auto",
        pr: 1,
      }}
    >
      {aulas.map((aula, index) => {
        const progresso =
          aula.duracao > 0
            ? Math.min((aula.pausado / aula.duracao) * 100, 100)
            : 0;

        const isAtivo = videoSelecionado === aula.videoId;

        return (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",

              borderRadius: 2,
              padding: 2,
              mb: 2,
              boxShadow: isAtivo
                ? "0px 2px 8px rgba(189, 111, 87, 0.3)"
                : "0px 1px 4px rgba(0, 0, 0, 0.1)",
              border: isAtivo ? "2px solid #BD6F57" : "none",
            }}
          >
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}
            >
              {aula.visto ? (
                <CheckCircleIcon sx={{ fontSize: 40, color: "#4CAF50" }} />
              ) : (
                <OndemandVideoIcon
                  sx={{
                    fontSize: 40,
                    color: isAtivo ? "#BD6F57" : "#555",
                  }}
                />
              )}

              <Box sx={{ flex: 1 }}>
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  sx={{ color: isAtivo ? "#BD6F57" : "inherit" }}
                >
                  {aula.titulo}
                </Typography>

                {aula.descricao && (
                  <Typography variant="body2" color="text.secondary">
                    {aula.descricao}
                  </Typography>
                )}

                {!aula.visto && progresso > 0 && (
                  <Box
                    sx={{
                      mt: 1,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LinearProgress
                      variant="determinate"
                      value={progresso}
                      sx={{
                        flex: 1,
                        height: 6,
                        borderRadius: 3,
                        backgroundColor: "#e0e0e0",
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: "#BD6F57",
                        },
                      }}
                    />
                    <Typography variant="caption" color="text.secondary">
                      {Math.round(progresso)}%
                    </Typography>
                  </Box>
                )}

                {isAtivo && (
                  <Typography
                    variant="caption"
                    sx={{ color: "#BD6F57", fontWeight: "bold", mt: 0.5 }}
                  >
                    ▶ Reproduzindo agora
                  </Typography>
                )}
              </Box>
            </Box>

            <Button
              variant="contained"
              onClick={aula.onClick}
              disabled={isAtivo}
              sx={{
                backgroundColor: aula.visto
                  ? "#4CAF50"
                  : isAtivo
                  ? "#ccc"
                  : "#E65C2A",
                "&:hover": {
                  backgroundColor: aula.visto
                    ? "#45a049"
                    : isAtivo
                    ? "#ccc"
                    : "#d14e20",
                },
                "&:disabled": {
                  backgroundColor: "#ccc",
                  color: "#666",
                },
                color: "#fff",
                fontWeight: "bold",
                minWidth: 100,
              }}
            >
              {aula.visto
                ? "✓ Assistido"
                : isAtivo
                ? "Reproduzindo"
                : progresso > 0
                ? "Continuar"
                : "Assistir"}
            </Button>
          </Box>
        );
      })}
    </Box>
  );
}
